import React from "react";
import { RouteComponentProps } from "react-router-dom";

import { useScrollToTop } from "../../../lib/hooks/useScrollToTop";
import useGrpcQuery from "../../../lib/hooks/useGrpcQuery";

import { PageHeader } from "../../../components/shared/PageHeader/PageHeader";
import { HandleLoadingState } from "../../../components/shared/HandleLoadingState/HandleLoadingState";
import { LoadingBox } from "../../../components/shared/LoadingBox/LoadingBox";
import { HandleRequestState } from "../../../components/shared/HandleRequestState/HandleRequestState";
import { CenteredBox } from "../../../components/shared/CenteredBox/CenteredBox";
import { EditGroupForm } from "../../../components/Groups/EditGroup/EditGroupForm";
import { tooltips } from "../../../lib/utils/tooltips";
import {
  GetGroupRequest,
  useGroupsRequests,
} from "../../../api/grpc/permissions/useGroupsRequests";
import { PermissionGroupDetailedResponse } from "../../../api/grpc/permissions/permissions";

interface Props {
  id: string;
}

export const EditGroup = ({
  match: {
    params: { id },
  },
}: RouteComponentProps<Props>) => {
  useScrollToTop();
  const { getPermissionGroup } = useGroupsRequests();
  const {
    data,
    error,
    loading,
    refetch: refetchGroup,
  } = useGrpcQuery<GetGroupRequest, PermissionGroupDetailedResponse>({
    method: getPermissionGroup,
    variables: { id },
  });

  return (
    <div className="TemplateManage">
      <PageHeader
        title="Edit group"
        hideBorder
        message={tooltips.groups.editGroup}
      />

      <HandleLoadingState
        loading={loading}
        loadingPlaceholder={<LoadingBox count={3} minHeight={70} />}
      >
        <HandleRequestState
          state={error !== undefined}
          placeholder={<CenteredBox>No group found!</CenteredBox>}
        >
          {data && (
            <EditGroupForm groupData={data} refetchGroup={refetchGroup} />
          )}
        </HandleRequestState>
      </HandleLoadingState>
    </div>
  );
};
